import Api from './Api';

const END_POINT = 'convenio';

export default {
    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    },
    async get_allPaginated(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}-list-paginated`, request);
    },
    async downloadExcel(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}/download`, request);
    },
}